import { render, staticRenderFns } from "./ModalAdicionarAndamento.vue?vue&type=template&id=27672351"
import script from "./ModalAdicionarAndamento.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarAndamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports